export enum GameType {
    session = 'session',
    oneday = 'oneday',
    test = 'test',
    
}